<template>
  <div>
    <Breadcrumb v-if="backofficeRole === 'super-admin'" origin-name="Organisations" origin-path="/" :current-name="this.fixName || 'Neue Organisationseinheit anlegen'" />
    <h3 v-if="isNewOrganisation">Neue Organisationseinheit anlegen</h3>
    <h3 v-else>Organisationseinheit bearbeiten</h3>
    <form @submit.prevent="submit">
      <div class="form-group">
        <label for="name-input">Name*</label>
        <input autofocus
               type="text"
               class="form-control"
               id="name-input"
               placeholder="Name"
               v-model="name"
               required />
      </div>
      <div class="form-group">
        <label for="description-input">Beschreibung</label>
        <textarea class="form-control"
                  id="description-input"
                  placeholder="Beschreibung"
                  v-model="description"></textarea>
      </div>
      <div class="form-group">
        <label for="address-input">Adresse</label>
        <textarea class="form-control"
                  id="address-input"
                  placeholder="Adresse"
                  v-model="address"></textarea>
      </div>
      <div class="form-group">
        <label for="phone-input">Telefonnummer</label>
        <textarea class="form-control"
                  id="phone-input"
                  placeholder="Telefonnummer"
                  v-model="phone"></textarea>
      </div>
      <div class="form-group">
        <label for="comment-input">Kommentar</label>
        <textarea class="form-control"
                  id="comment-input"
                  placeholder="Kommentar"
                  v-model="comment"></textarea>
      </div>
      <div class="form-group">
        <label for="paymentInfo-input">Zahlungsinformation</label>
        <textarea class="form-control"
                  id="paymentInfo-input"
                  placeholder="Zahlungsinformation"
                  v-model="paymentInfo"></textarea>
      </div>
      <div v-if="createdAt">Erstellt am {{ createdAt | dateFormat }}</div>
      <div class="hint mb-3">* Pflichtfeld</div>
      <button class="btn btn-primary" :class="{disabled: loading}">
        {{ isNewOrganisation ? "Anlegen" : "Speichern" }}
        <span v-if="loading" class="spinner"></span>
      </button>
      <button @click.prevent="toggleDialogVisible = true" v-if="!isNewOrganisation && backofficeRole === 'super-admin'" class="btn btn-danger delete-button" :class="{disabled: loading}">
        {{ active ? "Deaktivieren" : "Aktivieren" }}
        <span v-if="loading" class="spinner"></span>
      </button>
    </form>
    <Dialog :visible="toggleDialogVisible"
            :title="active ? 'Deaktivieren?' : 'Aktivieren?'"
            :ok-button-text="`Ja, ${active ? 'deaktivieren' : 'aktivieren'}!`"
            @cancel="toggleDialogVisible = false"
            @ok="toggleOrganisation"
            :message="`Wollen Sie die Organisation ${active ? 'deaktivieren' : 'aktivieren'}?`">

    </Dialog>
  </div>
</template>

<script>
import {communicator} from "@/util/communicator.js";
import {broadcast} from "@/util/eventHandler.js";
import Dialog from "@/components/partial/Dialog.vue";
import Breadcrumb from "@/components/partial/Breadcrumb.vue";
import {getBackofficeRole} from "@/util/authenticator";

export default {
  components: {Breadcrumb, Dialog},
  name: "OrganisationEditor",
  data() {
    return {
      backofficeRole: "",
      fixName: "",
      name: "",
      description: "",
      address: "",
      phone: "",
      comment: "",
      paymentInfo: "",
      createdAt: "",
      active: false,
      organisationId: undefined,
      loading: false,
      toggleDialogVisible: false,
      isNewOrganisation: false
    };
  },
  created() {
    if(this.$route.params.id) {
      const organisation = this.$store.state.organisations.find(e => String(e.id) === this.$route.params.id);
      this.mapOrganisation(organisation);
    }
    else this.isNewOrganisation = true;
    this.backofficeRole = getBackofficeRole();
  },
  methods: {
    onImageSelect(event) {
      if (event.target.files.length !== 1) return;
      this.image = event.target.files[0];
    },
    mapOrganisation(organisation) {
      this.fixName = organisation.name || "";
      this.name = organisation.name || "";
      this.description = organisation.description || "";
      this.address = organisation.address || "";
      this.phone = organisation.phone || "";
      this.comment = organisation.comment || "";
      this.paymentInfo = organisation.paymentInfo || "";
      this.createdAt = organisation.createdAt || "";
      this.latitude = organisation.latitude || "";
      this.longitude = organisation.longitude || "";
      this.active = organisation.active || false;
      this.organisationId = organisation.id;
    },
    async submit() {
      if(this.loading) return;
      try {
        this.loading = true;
        const data = {
          id: this.organisationId,
          name: this.name,
          description: this.description,
          address: this.address,
          phone: this.phone,
          comment: this.comment,
          paymentInfo: this.paymentInfo
        };
        if(this.organisationId) {
          data.id = this.organisationId;
        }
        const response = await communicator[this.isNewOrganisation ? "post" : "put"]("/organisations", data);
        if(this.isNewOrganisation) this.$router.push("/organisations");
        else broadcast("tab-changed");
        console.log("[AddOrganisation] Got response: ", response);
      } catch (e) {
        broadcast("error", e.response.data);
      }
      this.loading = false;
    },

    async toggleOrganisation() {
      if(this.loading) return;
      this.loading = true;
      this.toggleDialogVisible = false;
      try {
        await communicator.put("/organisations/", {
          id: this.organisationId,
          name: this.name,
          active: !this.active
        });
        this.$router.push("/organisations");
      } catch (e) {
        broadcast("error", e.response.data);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.delete-button {
  margin-left: 1rem;
  display: inline-block;
}
</style>
